// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"post-module--wrapper--1K0c3"};